import { render, staticRenderFns } from "./fishing.vue?vue&type=template&id=3dc6a1e4&scoped=true&"
import script from "./fishing.vue?vue&type=script&lang=js&"
export * from "./fishing.vue?vue&type=script&lang=js&"
import style0 from "./fishing.vue?vue&type=style&index=0&id=3dc6a1e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6a1e4",
  null
  
)

export default component.exports